import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../../Login/hooks/useAuthentication';
import { Button, ButtonTheme } from '@apply/components';

type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryPropertyDeleteButtonProps {
    deletePropertyButtonProps?: ButtonProps;
    printMode?: boolean;
}

export const ApplicationEntryPropertyDeleteButton: React.FC<ApplicationEntryPropertyDeleteButtonProps> = ({
    deletePropertyButtonProps,
    printMode = false,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    if (!deletePropertyButtonProps || printMode) return null;

    return (
        <>
            <div style={{ float: 'right', paddingRight: '1rem' }}>
                <Button
                    id={deletePropertyButtonProps.id}
                    dataTestid={deletePropertyButtonProps.dataTestid}
                    theme={ButtonTheme.LinkRed}
                    disabled={deletePropertyButtonProps.disabled}
                    handleClick={deletePropertyButtonProps.handleClick}
                    visible={!printMode && deletePropertyButtonProps.visible}
                >
                    {deletePropertyButtonProps.children}
                </Button>
            </div>
        </>
    );
};
